"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Inner = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _shapes = require("../shapes");

var _react = _interopRequireWildcard(require("react"));

var _ErrorBoundary = require("../../Utilities/ErrorBoundary");

var _Footer = _interopRequireDefault(require("../Footer"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Sidebar = _interopRequireDefault(require("../Sidebar"));

var _Topbar = _interopRequireDefault(require("../Topbar"));

var _NavigationRail = _interopRequireDefault(require("../../NavigationRail"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withWidth = require("@material-ui/core/withWidth");

var _styles = require("./styles");

var _ThemeHelper = require("../../Utilities/ThemeHelper");

var _styles2 = require("@material-ui/core/styles");

var _ProductList = _interopRequireDefault(require("../Sidebar/ProductList"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Inner = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Inner, _Component);

  var _super = _createSuper(Inner);

  /**
   * These prop-types should be duplicates from "./Page"
   */
  function Inner(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Inner);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleProductList", function (theState) {
      // If theState is a boolean, set the state to that value
      if (typeof theState === "boolean") {
        if (_this.state.productListOpen !== theState) {
          _this.setState({
            productListOpen: theState
          });
        }
      } // Otherwise just toggle
      else {
          _this.setState({
            productListOpen: !_this.state.productListOpen
          });
        }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hideMainNav", function () {
      _this.setState(function (prevState) {
        return {
          mainNavOpen: false
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDrawerToggle", function () {
      _this.setState(function (prevState) {
        return {
          mainNavOpen: !prevState.mainNavOpen
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.shouldCollapseMenu !== _this.props.shouldCollapseMenu) {
        _this.setState({
          mainNavOpen: true
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          accountMenuOptions = _this$props.accountMenuOptions,
          classes = _this$props.classes,
          children = _this$props.children,
          disableSidebar = _this$props.disableSidebar,
          disableTopbar = _this$props.disableTopbar,
          disableFooter = _this$props.disableFooter,
          footerMessage = _this$props.footerMessage,
          helpMenuOptions = _this$props.helpMenuOptions,
          productLogo = _this$props.productLogo,
          navigationSections = _this$props.navigationSections,
          productNavSections = _this$props.productNavSections,
          identityServerSdk = _this$props.identityServerSdk,
          width = _this$props.width,
          currentOrg = _this$props.currentOrg,
          currentOrgSettings = _this$props.currentOrgSettings,
          onOrgSelect = _this$props.onOrgSelect,
          customSidebar = _this$props.customSidebar,
          customTopbar = _this$props.customTopbar,
          disableProductList = _this$props.disableProductList,
          product = _this$props.product,
          type = _this$props.type,
          forcePadding = _this$props.forcePadding,
          disableMargin = _this$props.disableMargin,
          shouldCollapseMenu = _this$props.shouldCollapseMenu,
          navigationRailProps = _this$props.navigationRailProps;
      var _this$state = _this.state,
          mainNavOpen = _this$state.mainNavOpen,
          productListOpen = _this$state.productListOpen;
      var shouldRenderTopbar = !disableTopbar && (!(0, _withWidth.isWidthUp)("md", width) || customTopbar || accountMenuOptions && accountMenuOptions.show || helpMenuOptions && helpMenuOptions.show);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("prmbl-pageInner", (0, _defineProperty2.default)({}, classes.root, children), classes.pageInner)
      }, shouldRenderTopbar && /*#__PURE__*/_react.default.createElement(_Topbar.default, {
        id: id + "-page-topbar",
        disableSidebar: disableSidebar,
        accountMenuOptions: accountMenuOptions,
        helpMenuOptions: helpMenuOptions,
        onMenuClicked: _this.handleDrawerToggle,
        identityServerSdk: identityServerSdk,
        type: type,
        currentOrg: currentOrg,
        currentOrgSettings: currentOrgSettings,
        width: width,
        shouldCollapseMenu: shouldCollapseMenu,
        product: product,
        productLogo: productLogo,
        disableProductList: disableProductList,
        toggleProductList: _this.toggleProductList,
        productListOpen: productListOpen
      }, customTopbar), !disableSidebar && /*#__PURE__*/_react.default.createElement(_Sidebar.default, {
        id: id + "-page-sidebar",
        mainNavOpen: mainNavOpen,
        navigationSections: navigationSections,
        productLogo: productLogo,
        width: width,
        hideMainNav: _this.hideMainNav,
        productNavSections: productNavSections,
        identityServerSdk: identityServerSdk,
        currentOrg: currentOrg,
        currentOrgSettings: currentOrgSettings,
        onOrgSelect: onOrgSelect,
        disableProductList: disableProductList,
        type: type,
        product: product,
        shouldCollapseMenu: shouldCollapseMenu,
        toggleProductList: _this.toggleProductList,
        productListOpen: productListOpen
      }, customSidebar), (disableSidebar || shouldCollapseMenu) && navigationRailProps && /*#__PURE__*/_react.default.createElement(_NavigationRail.default, (0, _extends2.default)({}, navigationRailProps, {
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.offsetTopBar, shouldRenderTopbar))
      })), !disableProductList && disableSidebar && /*#__PURE__*/_react.default.createElement(_ProductList.default, {
        id: id + "-productList",
        identityServerSdk: identityServerSdk,
        open: productListOpen,
        onToggle: _this.toggleProductList,
        disableSidebar: disableSidebar,
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.offsetTopBar, shouldRenderTopbar))
      }), (children || footerMessage) && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.contentWrap, (0, _defineProperty2.default)({}, classes.hasTopbar, shouldRenderTopbar || forcePadding), (0, _defineProperty2.default)({}, classes.hasSidebar, !disableSidebar && !shouldCollapseMenu || forcePadding), (0, _defineProperty2.default)({}, classes.hasNavigationRail, disableSidebar && navigationRailProps), "mui-fixed")
      }, /*#__PURE__*/_react.default.createElement("main", {
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.content, !disableMargin), classes.main)
      }, children ? /*#__PURE__*/_react.default.createElement(_ErrorBoundary.ErrorBoundary, null, children) : undefined), !disableFooter && footerMessage && /*#__PURE__*/_react.default.createElement(_Footer.default, {
        id: id + "-page-footer"
      }, footerMessage)));
    });
    _this.state = {
      mainNavOpen: false,
      productListOpen: false
    };
    return _this;
  }

  return Inner;
}(_react.Component);

exports.Inner = Inner;
(0, _defineProperty2.default)(Inner, "propTypes", {
  id: _propTypes.default.string.isRequired,
  accountMenuOptions: _propTypes.default.shape({
    includeDefault: _propTypes.default.bool,
    menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      display: _propTypes.default.string.isRequired,
      action: _propTypes.default.func.isRequired
    })),
    show: _propTypes.default.bool,
    platformBaseUrl: _propTypes.default.string,
    signoutOfProduct: _propTypes.default.func,
    signoutUrl: _propTypes.default.string
  }),
  classes: _propTypes.default.object.isRequired,
  children: _propTypes.default.node,
  disableSidebar: _propTypes.default.bool,
  disableTopbar: _propTypes.default.bool,
  disableFooter: _propTypes.default.bool,
  navigationSections: _shapes.NavigationSections,
  productLogo: _propTypes.default.node,
  footerMessage: _propTypes.default.node,
  currentOrg: _propTypes.default.string,
  currentOrgSettings: _propTypes.default.shape({
    name: _propTypes.default.string,
    id: _propTypes.default.string,
    settings: _propTypes.default.object
  }),
  onOrgSelect: _propTypes.default.func,
  disableProductList: _propTypes.default.bool,
  type: _propTypes.default.oneOf(["internal", "external"]),

  /**
   * @ignore
   *
   * Utilized By:
   * LiveEdit,
   * Expansion Panel: Added so that ExpansionPanel could apply classes to the actions.
   *
   * Preamble => Page
   */
  className: _propTypes.default.string,
  productNavSections: _shapes.ProductNavSections,
  identityServerSdk: _propTypes.default.object,
  helpMenuOptions: _propTypes.default.shape({
    menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      display: _propTypes.default.string.isRequired,
      action: _propTypes.default.func.isRequired
    })),
    show: _propTypes.default.bool
  }),
  width: _propTypes.default.string.isRequired,
  customSidebar: _propTypes.default.node,
  customTopbar: _propTypes.default.node,
  shouldCollapseMenu: _propTypes.default.bool,

  /**
   * Sets product colors and logo automatically. Can be overridden by primaryHex and productLogo
   */
  product: _propTypes.default.oneOf(Object.keys(_ThemeHelper.themes)),
  forcePadding: _propTypes.default.bool,
  disableMargin: _propTypes.default.bool,
  navigationRailProps: _propTypes.default.object
});
(0, _defineProperty2.default)(Inner, "defaultProps", {
  navigationSections: {},
  productNavSections: [],
  accountMenuOptions: {
    includeDefault: true
  },
  classes: {}
});

var _default = (0, _styles2.withStyles)(_styles.styles)(Inner);

exports.default = _default;